import { Directory, Document } from '../../../models';

export function isDirectory(object: Directory | Document): object is Directory {
  return 'directoryPath' in object;
}
